var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('loading-spinner',{attrs:{"small":""}}):(_vm.dataCategory === 'Continuous')?_c('histogram-sparkline',{key:'hsl-' + _vm.datasetId + '-' + _vm.type + '-' + _vm.scaleId,attrs:{"data":_vm.data}}):_c('column-chart',{attrs:{"data":_vm.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }